/** @format */

import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import ThemeSwitch from '../../Atoms/Theme/ThemeSwitch';
import { useAppContext } from '../../../store/store.app';
import { USR_PROFILE_MENU, THEMES } from '../../../Constants/commons';
import { clearAuthSession } from '../../../Util/authUtils';

export default function Profile(props) {
  const { anchorElUser, handleCloseUserMenu } = props;
  const {
    appStore: { activeTheme },
    ...appCtx
  } = useAppContext();

  const navigate = useNavigate();

  const handleSettingItem = (event) => {
    console.log(event);
    clearAuthSession();
    localStorage.setItem('params', null);
    navigate('/login');
    location.reload();
  };

  return (
    <Menu
      id="menu-appbar"
      sx={{ mt: '45px', fontFamily: 'Inter' }}
      anchorEl={anchorElUser}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      disableScrollLock
      PaperProps={{
        sx: {
          overflowX: 'hidden',
          maxWidth: 'calc(100vw - 16px)',
        },
      }}
      open={Boolean(anchorElUser)}
      onClose={handleCloseUserMenu}
    >
      {USR_PROFILE_MENU.map((setting, index) => {
        const { displayText, Icon, disabled, page } = setting;
        return (
          <MenuItem
            disabled={disabled}
            key={index}
            onClick={(event) => {
              if (displayText === 'Logout') {
                handleSettingItem(event);
              }
              handleCloseUserMenu();
            }}
          >
            <ListItemIcon>
              <Icon />
            </ListItemIcon>
            <ListItemText sx={{ fontFamily: 'Inter' }}>
              {page ? (
                <NavLink
                  to={setting.linkText}
                  style={({ isActive, isPending, isTransitioning }) => {
                    return {
                      color: isActive ? 'skyblue' : 'inherit',
                      textDecoration: 'none',
                    };
                  }}
                >
                  {displayText}
                </NavLink>
              ) : (
                displayText
              )}
            </ListItemText>
          </MenuItem>
        );
      })}
      <Divider />
      <Box
        component="li"
        sx={{ display: 'flex', justifyContent: 'center', display: 'none' }}
      >
        <ThemeSwitch
          onChange={(ev) => {
            const theme = ev.target.checked ? THEMES.DARK : THEMES.LIGHT;
            appCtx.updateTheme(theme);
            localStorage.setItem('theme', theme);
            // location.reload();
          }}
          checked={activeTheme === THEMES.DARK}
        />
      </Box>
    </Menu>
  );
}
